import React, { useEffect, useState } from 'react'
import objectPath from 'object-path'
import AutocompleteContent from '../../autocomplete/index'
import { checkLockMode } from '../action/Column'

const CustomAutocomplete = (props) => {
  let {
    ui,
    rowData,
    value,
    onUpdateRowData,
    tableRef,
    error,
    column,
    handleKeyDown,
  } = props
  let { optionType = {}, mapOther } = ui

  const list = objectPath.get(ui, `${optionType}`) || {}
  const { optionValue = 'value' } = list
  const [labelField, setLabelField] = useState(value)
  const [options, setOptions] = useState([])

  const onEditingApproved = (mode, newData, oldData) => {
    let hasEditingApproved = objectPath.has(
      tableRef,
      'current.onEditingApproved',
    )
    if (hasEditingApproved) {
      tableRef.current.onEditingApproved(mode, newData, oldData)
    }
  }

  const updateData = (dataValue, field = ui.field) => {
    objectPath.set(rowData, field, dataValue)
    onUpdateRowData(rowData)
  }

  const clearData = (field = ui.field) => {
    if (field.split('.').length > 1) {
      let firstKey = field.split('.').shift()
      objectPath.set(rowData, firstKey, undefined)
    } else {
      objectPath.set(rowData, field, undefined)
    }
    onUpdateRowData(rowData)
  }

  const updateMapOther = (option) => {
    if (mapOther) {
      if (option) {
        mapOther.forEach(({ field, value }) => {
          let optionValue = objectPath.get(option, value)
          updateData(optionValue, field)
          updateData(optionValue, `@${field}`)
        })
      } else {
        mapOther.forEach(({ field }) => {
          clearData(field)
          clearData(`@${field}`)
        })
      }
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.target.value === value) {
        let hasId = objectPath.has(rowData, 'tableData.id')
        let hasMode = objectPath.has(rowData, 'mode')
        let mode = hasMode ? rowData.mode : hasId ? 'update' : 'add'
        let oldData = objectPath.get(tableRef, 'current.state.lastEditingRow')
        if (mode === 'add') {
          let found = options.find(
            (option) => objectPath.get(option, optionValue) === value,
          )
          objectPath.set(rowData, ui.field, value)
          if (mapOther) {
            mapOther.forEach(({ field, value }) => {
              let optionValue = objectPath.get(found, value)
              objectPath.set(rowData, field, optionValue)
            })
          }
        }
        onEditingApproved(mode, rowData, oldData)
      }
    }
  }

  let isLockEdit = checkLockMode(column, rowData)
  if (isLockEdit) {
    return objectPath.get(rowData, ui.field)
  }

  return (
    <>
      <AutocompleteContent
        {...props}
        uischema={ui}
        value={objectPath.get(rowData, ui.field)}
        labelField={labelField}
        setLabelField={setLabelField}
        options={options}
        setOptions={setOptions}
        updateData={updateData}
        updateMapOther={updateMapOther}
        onKeyDown={onKeyDown}
        rowUpdate={rowData}
        column={column}
        isFromTable={true}
        onUpdateRowData={onUpdateRowData}
        error={error}
        handleKeyDown={(e) => handleKeyDown(e, rowData)}
      />
    </>
  )
}

export default CustomAutocomplete
